<template>
  <div class="burger-menu" :class="classMenu">
    <Logo />
    <el-scrollbar
      class="burger-menu__scrollbar"
      wrap-class="burger-menu__scrollbar--wrapper">
      <Menu />
    </el-scrollbar>
  </div>
</template>

<script>
import Logo from '@/components/layout/Logo.vue';
import Menu from '@/components/layout/Menu.vue';

export default {
  name: 'burgerMenu',
  components: {
    Menu,
    Logo,
  },
  props: {
    isActived: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    classMenu() {
      return {
        'burger-menu--active': this.isActived,
      };
    },
  },
  watch: {
    isActived(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    },
  },
};
</script>

<style lang="scss">

.burger-menu {
  position: fixed;
  display: flex;
  flex: 1 1 0%;
  flex-direction: column;
  height: 100%;
  width: $--left-menu-size;
  left: -($--left-menu-size);
  top: 0;
  bottom: 0;
  background-color: $--color-light-grey;
  z-index: 1001;
  transition: all .5s ease;

  &__scrollbar {
    height: 100vh;
    overflow-x: hidden;
    &--wrapper {
      overflow-y: auto;
      overflow-x: hidden;
      .el-scrollbar__view {
        width: calc(#{$--left-menu-size} - 12px);
      }
    }
  }
  &--active {
    box-shadow: 0 0 2rem 0 rgba(0,0,0,.2);
    left: 0;
  }
}
</style>
